"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spirals = exports.calcSpiral = void 0;
var calcSpiral = function (r) {
    var spiral = [];
    var add = function (ox, oy) {
        spiral.push({ x: ox, y: oy });
    };
    if (r >= 0) {
        add(0, 0);
    }
    if (r >= 0.5) {
        add(-1, 0);
        add(0, -1);
        add(1, 0);
        add(0, 1);
    }
    if (r >= 1.5) {
        add(-1, -1);
        add(1, -1);
        add(1, 1);
        add(-1, 1);
    }
    if (r >= 2) {
        add(-2, 0);
        add(0, -2);
        add(2, 0);
        add(0, 2);
    }
    if (r >= 2.5) {
        add(-2, -1);
        add(-1, -2);
        add(1, -2);
        add(2, -1);
        add(2, 1);
        add(1, 2);
        add(-1, 2);
        add(-2, 1);
    }
    if (r >= 3) {
        add(-3, 0);
        add(0, -3);
        add(3, 0);
        add(0, 3);
    }
    return spiral;
};
exports.calcSpiral = calcSpiral;
exports.spirals = {
    0: (0, exports.calcSpiral)(0),
    0.5: (0, exports.calcSpiral)(0.5),
    1: (0, exports.calcSpiral)(1),
    1.5: (0, exports.calcSpiral)(1.5),
    2: (0, exports.calcSpiral)(2),
    2.5: (0, exports.calcSpiral)(2.5),
    3: (0, exports.calcSpiral)(3),
};
